(() => {
  document.addEventListener('click', event => {
    const link = event.target.closest('.wv-mobile-menu a[href]');
    if (link) link.closest('.wv-mobile-menu').open = false;
  });
  const initialize = (root = document) => {
    root.querySelectorAll('[data-wv-comparison-carousel]').forEach(carousel => {
      if (carousel.dataset.carouselInitialized) return;
      carousel.dataset.carouselInitialized = 'true';
      const track = carousel.querySelector('.wv-compare-mobile-track');
      const headings = [...track.querySelectorAll('.wv-compare-mobile-card')];
      const previous = carousel.querySelector('[data-comparison-prev]');
      const next = carousel.querySelector('[data-comparison-next]');
      const count = carousel.querySelector('[data-comparison-count]');
      const mobile = matchMedia('(max-width:760px)');
      const offsets = () => headings.map(heading => heading.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft);
      const position = () => {
        const positions = offsets();
        return positions.reduce((closest, value, index) => Math.abs(value - positions[0] - track.scrollLeft) < Math.abs(positions[closest] - positions[0] - track.scrollLeft) ? index : closest, 0);
      };
      const update = () => {
        const selected = position();
        previous.disabled = selected === 0;
        next.disabled = selected === headings.length - 1;
        count.textContent = `${String(selected + 1).padStart(2,'0')} / ${String(headings.length).padStart(2,'0')}`;
      };
      const select = index => {
        if (!mobile.matches) return;
        const positions = offsets();
        const selected = Math.max(0, Math.min(headings.length - 1, index));
        track.scrollTo({left:positions[selected] - positions[0],behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
      };
      previous.addEventListener('click', () => select(position() - 1));
      next.addEventListener('click', () => select(position() + 1));
      track.addEventListener('keydown', event => {
        if (!mobile.matches || event.target !== track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        select(event.key === 'Home' ? 0 : event.key === 'End' ? headings.length - 1 : position() + (event.key === 'ArrowRight' ? 1 : -1));
      });
      let scrollFrame = 0;
      track.addEventListener('scroll', () => {
        if (scrollFrame) return;
        scrollFrame = requestAnimationFrame(() => { update(); scrollFrame = 0; });
      }, {passive:true});
      window.addEventListener('resize', update, {passive:true});
      update();
    });
    root.querySelectorAll('[data-wv-home]').forEach(home => {
      if (home.dataset.initialized) return;
      home.dataset.initialized = 'true';
      const productTrack = home.querySelector('[data-product-carousel]');
      if (productTrack) {
        const cards = [...productTrack.querySelectorAll('.wv-product-card')];
        const previous = home.querySelector('[data-product-prev]');
        const next = home.querySelector('[data-product-next]');
        const count = home.querySelector('[data-product-count]');
        const mobile = matchMedia('(max-width:760px)');
        const position = () => {
          const origin = cards[0]?.offsetLeft || 0;
          return cards.reduce((closest, card, index) => Math.abs(card.offsetLeft - origin - productTrack.scrollLeft) < Math.abs(cards[closest].offsetLeft - origin - productTrack.scrollLeft) ? index : closest, 0);
        };
        const updateProducts = () => {
          const selected = position();
          if (previous) previous.disabled = selected === 0;
          if (next) next.disabled = selected === cards.length - 1;
          if (count) count.textContent = `${String(selected + 1).padStart(2,'0')} / ${String(cards.length).padStart(2,'0')}`;
        };
        const showProduct = index => {
          if (!mobile.matches || !cards.length) return;
          const selected = Math.max(0, Math.min(cards.length - 1, index));
          productTrack.scrollTo({left:cards[selected].offsetLeft - cards[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
        };
        previous?.addEventListener('click', () => showProduct(position() - 1));
        next?.addEventListener('click', () => showProduct(position() + 1));
        productTrack.addEventListener('keydown', event => {
          if (!mobile.matches || event.target !== productTrack || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          showProduct(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : position() + (event.key === 'ArrowRight' ? 1 : -1));
        });
        let productFrame = 0;
        productTrack.addEventListener('scroll', () => {
          if (productFrame) return;
          productFrame = requestAnimationFrame(() => { updateProducts(); productFrame = 0; });
        }, {passive:true});
        window.addEventListener('resize', updateProducts, {passive:true});
        updateProducts();
      }
      const hero = home.querySelector('.wv-hero');
      const poster = home.querySelector('.wv-home-poster');
      const skip = home.querySelector('[data-wv-skip]');
      const showCopy = () => hero.classList.remove('wv-cinema-opening');
      const finish = () => { showCopy(); hero.classList.add('wv-intro-finished'); if (skip) skip.hidden = true; };
      if (poster && matchMedia('(min-width:761px)').matches && !matchMedia('(prefers-reduced-motion:reduce)').matches) {
        const duration = (Number(home.dataset.openingDuration) || 5) * 1000;
        hero.classList.add('wv-cinema-opening','wv-pullback');
        poster.addEventListener('animationend', finish, { once:true });
        setTimeout(showCopy, 450);
        setTimeout(finish, duration + 100);
        if (skip) skip.addEventListener('click', finish);
      } else finish();
      const tabs = [...home.querySelectorAll('[data-guide-tab]')];
      const panels = [...home.querySelectorAll('[role="tabpanel"]')];
      let index = 0;
      const select = (value, focus = false) => {
        if (!tabs.length) return;
        index = (value + tabs.length) % tabs.length;
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        panels.forEach((panel, i) => panel.hidden = i !== index);
        const counter = home.querySelector('.wv-guide-count');
        if (counter) counter.textContent = `${String(index + 1).padStart(2,'0')} / ${String(tabs.length).padStart(2,'0')}`;
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(i));
        tab.addEventListener('keydown', event => {
          if (['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
            event.preventDefault();
            select(event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1), true);
          }
        });
      });
      home.querySelector('[data-guide-prev]')?.addEventListener('click', () => select(index - 1));
      home.querySelector('[data-guide-next]')?.addEventListener('click', () => select(index + 1));
      select(0);
    });
    root.querySelectorAll('[data-wv-lifestyle]').forEach(carousel => {
      if (carousel.dataset.lifestyleInitialized) return;
      carousel.dataset.lifestyleInitialized = 'true';
      const tabs = [...carousel.querySelectorAll('[data-lifestyle-tab]')];
      const panels = [...carousel.querySelectorAll('[data-lifestyle-panel]')];
      let active = 0;
      const select = (value, focus = false) => {
        active = (value + panels.length) % panels.length;
        panels.forEach((panel, i) => panel.hidden = i !== active);
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === active)); tab.tabIndex = i === active ? 0 : -1; });
        carousel.querySelector('[data-lifestyle-count]').textContent = `${String(active + 1).padStart(2, '0')} / ${String(panels.length).padStart(2, '0')}`;
        if (focus) tabs[active].focus();
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(i));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          select(event.key === 'Home' ? 0 : event.key === 'End' ? panels.length - 1 : active + (event.key === 'ArrowRight' ? 1 : -1), true);
        });
      });
      carousel.querySelector('[data-lifestyle-prev]').addEventListener('click', () => select(active - 1));
      carousel.querySelector('[data-lifestyle-next]').addEventListener('click', () => select(active + 1));
      const stage = carousel.querySelector('.wv-lifestyle-stage');
      let touchStart;
      stage.addEventListener('touchstart', event => { touchStart = {x:event.changedTouches[0].clientX,y:event.changedTouches[0].clientY}; }, {passive:true});
      stage.addEventListener('touchend', event => {
        if (!touchStart) return;
        const dx = event.changedTouches[0].clientX - touchStart.x;
        const dy = event.changedTouches[0].clientY - touchStart.y;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) select(active + (dx < 0 ? 1 : -1));
        touchStart = undefined;
      }, {passive:true});
      select(0);
    });
    root.querySelectorAll('[data-wv-product]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const frames = [...section.querySelectorAll('[data-gallery-frame]')];
      const thumbs = [...section.querySelectorAll('[data-gallery-thumb]')];
      thumbs.forEach((button, index) => button.addEventListener('click', () => {
        frames.forEach((frame, i) => frame.hidden = index !== i);
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(index === i)));
      }));
      const dialog = section.querySelector('dialog');
      const zoomImage = dialog?.querySelector('img');
      section.querySelectorAll('[data-zoom-url]').forEach(button => button.addEventListener('click', () => {
        if (!dialog || !zoomImage) return;
        zoomImage.src = button.dataset.zoomUrl;
        zoomImage.alt = button.dataset.zoomAlt || '';
        dialog.querySelector('.wv-full-image-link').href = button.dataset.zoomUrl;
        dialog.showModal();
      }));
      dialog?.querySelector('[data-close-zoom]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      const quantity = section.querySelector('[name="quantity"]');
      section.querySelectorAll('[data-open-howto]').forEach(control => control.addEventListener('click', event => {
        event.preventDefault();
        const target = section.querySelector('[data-howto]');
        if (!target) return;
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth',block:'start'});
      }));
      section.querySelectorAll('[data-quantity-change]').forEach(button => button.addEventListener('click', () => {
        if (!quantity) return;
        quantity.value = Math.max(1, Math.min(99, (parseInt(quantity.value,10) || 1) + Number(button.dataset.quantityChange)));
        quantity.dispatchEvent(new Event('change', { bubbles:true }));
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target.parentElement || document));
})();
